
/**
 * App wide configurations
 */
const Config = {
	// Python FastApi server
	//serverUrl: "http://localhost:8000"

	// PROD
	serverUrl: "https://worten-logistic-prod-dot-picea-online-worten.ey.r.appspot.com"
	
	// STAGING
	//serverUrl: "https://worten-logistic-staging-dot-picea-online-worten.ey.r.appspot.com"
}

export default Config
